<div class="min-h-screen bg-base-200">
  @if (reportQuery.isPending()) {
    <div class="flex items-center justify-center py-24">
      <nz-spin nzSimple nzSize="large"></nz-spin>
    </div>
  } @else if (reportQuery.isError()) {
    <div class="mx-auto max-w-md px-4 py-24 text-center">
      <span nz-icon nzType="exclamation-circle" class="text-4xl text-error"></span>
      <h2 class="mt-3 text-lg font-semibold text-base-content">Couldn't load the audit report</h2>
      <p class="mt-1 text-sm text-base-content/60">The trip audit report could not be loaded. Please try again.</p>
      <button nz-button nzType="primary" class="mt-4" (click)="retry()">Retry</button>
    </div>
  } @else {
    @if (report(); as r) {
      <buspro-trip-audit-report
        [report]="r"
        backLabel="Back to My Audits"
        [exportingPdf]="exportingPdf()"
        [canPreviewPdf]="true"
        (back)="back()"
        (exportPdf)="exportPdf()"
        (previewPdf)="previewPdf()"
      />
      <buspro-pdf-preview
        [source]="previewFile()"
        [loading]="previewLoading()"
        [title]="r.header.routeName + ' · audit report'"
        (closed)="closePreview()"
        (download)="downloadPreviewed()"
      ></buspro-pdf-preview>
    }
  }
</div>
